<div class="select select--pristine select--bottom select--touched">
	<div class="select__dropdown-panel select--bottom select__dropdown-panel--open" [class.select__multiple]="multiple">
		<div *ngIf="(((filteredItems && filteredItems.length) || (value && value.length))) && selectAllOption">
			<div class="select__dropdown-panel-items scroll-host" wfmScrollbar>
				<div
					role="option"
					class="select__option"
					[class.select__option--selected]="isSelectedAll"
					(click)="toggleSelectAll()"
				>
          <span class="select__multiple-check-icon-wrapper" [class.select__multiple-hide-check-icon]="!isSelectedAll">
            <ng-container [ngTemplateOutlet]="checkIcon"> </ng-container>
          </span>
					<span class="select__option-label"> ({{ 'core.label.selectAll' | translate }}) </span>
				</div>
			</div>
			<hr class="u-mv0"/>
		</div>

		<div *ngIf="search" class="select__panel-header-input">
      <div class="flex flex--middle" style="position: relative">
        <input
          #searchInput
          type="text"
          class="textbox u-pl---"
          placeholder="{{ searchLabel | translate }}"
          id="search-container-search-field-input"
          [(ngModel)]="query"
          (keyup.enter)="!enableInternalSearch && querySearchStr()"
          (ngModelChange)="enableInternalSearch && updateFilteredItems()"
        />
        <div class="filter__icon">
          <div class="svg-icon__container" *ngIf="!!query" (click)="removeFilter()">
            <svg-icon
              style="height: 1.6rem"
              name="ico-close-16"
              [svgStyle]="{ 'width.px': '16', 'height.px': '16', fill: 'currentColor' }"
            ></svg-icon>
          </div>
          <div class="svg-icon__container" *ngIf="enableInternalSearch && !query" (click)="!enableInternalSearch && querySearchStr()">
            <svg-icon
              style="height: 1.6rem"
              name="ico-search-16"
              [svgStyle]="{ 'width.px': '16', 'height.px': '16', fill: 'currentColor' }"
            ></svg-icon>
          </div>
        </div>
      </div>
		</div>

		<div
			class="select__dropdown-panel-items scroll-host"
			#panelScroll
			wfmScrollbar
			[class.no-max-height]="unsetMaxHeight"
		>
			<div>
				<div
					*ngIf="!required && !multiple"
					role="option"
					id="clear_option_row"
					class="select__option"
					(click)="itemClick(undefined)"
				>
					<label>
						<span class="select__option-label--placeholder">
              {{ 'core.label.clear' | translate }}
            </span>
						<span class="select__option-label--description-column"></span>
					</label>
				</div>

				<div class="highlight" *ngIf="multiple && highlightSelected && (value || []).length">
					{{ 'core.label.selected' | translate }}
				</div>
				<div *ngIf="multiple && highlightSelected">
					<ng-container *ngFor="let item of value; index as i">
						<ng-container [ngTemplateOutlet]="option" [ngTemplateOutletContext]="{ index: i, item: item }">
						</ng-container>
					</ng-container>
				</div>

				<div class="highlight" *ngIf="highlightSelected && filteredItems && filteredItems.length">
					{{ 'core.label.available' | translate }}
				</div>

				<ng-container *ngIf="!dateRangeOptions">
					<ng-container *ngFor="let item of filteredItems || items; index as i">
						<ng-container *ngIf="grouping">
							<ng-container [ngTemplateOutlet]="groupOption" [ngTemplateOutletContext]="{ item: item }"></ng-container>

							<ng-container *ngFor="let gItem of item.items; index as gi">
								<ng-container
									[ngTemplateOutlet]="option"
									[ngTemplateOutletContext]="{ index: '' + i + '-' + gi, item: gItem }"
								>
								</ng-container>
							</ng-container>
						</ng-container>

						<ng-container *ngIf="!grouping">
							<ng-container [ngTemplateOutlet]="option" [ngTemplateOutletContext]="{ index: i, item: item }">
							</ng-container>
						</ng-container>
					</ng-container>
				</ng-container>
				<ng-container *ngIf="dateRangeOptions">
					<ng-container *ngTemplateOutlet="dateRangeOptionsTemplate"></ng-container>
				</ng-container>
			</div>
		</div>
	</div>
</div>

<ng-template #dateRangeOptionsTemplate>
	<div class="flex flex--row flex--nowrap flex--justify flex--top">
		<div id="past-date-options" class="u--1/2">
			<ng-container *ngFor="let item of items | slice:0:11; index as i">
				<ng-container [ngTemplateOutlet]="option" [ngTemplateOutletContext]="{ index: i, item: item }"></ng-container>
			</ng-container>
		</div>
		<div id="future-date-options" class="u--1/2">
			<ng-container *ngFor="let item of items | slice:-6; index as i">
				<ng-container [ngTemplateOutlet]="option" [ngTemplateOutletContext]="{ index: i, item: item }"></ng-container>
			</ng-container>
		</div>
	</div>
</ng-template>

<ng-template #option let-i="index" let-item="item">
	<div
		role="option"
		class="select__option"
		id="search-container-item-{{ i }}"
		[ngStyle]="itemStyle"
		[class.select__option--sub-item]="grouping"
		[class.select__option--selected]="value && (value === item || (value.indexOf && value.indexOf(item) >= 0))"
		[class.select__option--disabled]="
      (maxSelection && value && value.length === maxSelection && value.indexOf(item) === -1) ||
      (!itemTemplate && isListOfObjects && item.disabled)
    "
		(click)="
      !((maxSelection && value && value.length === maxSelection && value.indexOf(item) === -1) || (!itemTemplate && isListOfObjects && item.disabled)) &&
      itemClick(item)
    "
	>
    <span
	    class="select__multiple-check-icon-wrapper"
	    *ngIf="multiple"
	    [class.select__multiple-hide-check-icon]="!value || value.indexOf(item) === -1"
    >
      <ng-container [ngTemplateOutlet]="checkIcon"> </ng-container>
    </span>

		<span class="select__option-label"> </span>
		<span class="select__option-label">
      <ng-container
	      *ngIf="itemTemplate"
	      [ngTemplateOutlet]="itemTemplate"
	      [ngTemplateOutletContext]="{ index: i, item: item }"
      >
      </ng-container>
      <ng-container *ngIf="!itemTemplate">
        <span
	        *ngIf="iconField && item && item[iconField]"
	        [ngStyle]="{ 'margin-right': '5px', position: 'relative', top: '2px' }"
        >
          <svg-icon [name]="item[iconField]" [svgStyle]="{ 'width.px': '16', 'height.px': '16', 'fill': 'currentColor' }">
          </svg-icon>
        </span>
        <span id="{{ 'select-item' + (isListOfObjects ? item[labelField] : item) }}">{{
	        '' + (translationEnabled ? ((isListOfObjects ? item[labelField] : item) | translate) : (isListOfObjects ? item[labelField] : item))
	        }}</span>
      </ng-container>
    </span>
	</div>
</ng-template>

<ng-template #groupOption let-item="item">
	<div class="select__option select__option--group">
		<span>{{ item.label }}</span>
	</div>
</ng-template>

<ng-template #checkIcon>
	<svg
		id="Layer_1"
		data-name="Layer 1"
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		viewBox="0 0 16 16"
		class="select__multiple-check-icon"
		style="fill: currentColor"
	>
		<path
			d="M6.5,12.5a1,1,0,0,1-.71-.29l-3.5-3.5A1,1,0,1,1,3.71,7.29l2.79,2.8,5.79-5.8a1,1,0,1,1,1.42,1.42l-6.5,6.5A1,1,0,0,1,6.5,12.5Z"
		></path>
	</svg>
</ng-template>
